import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/auth.js";
import * as roles from "@/store/modules/roles.js";
import * as partes from "@/store/modules/partes.js";
import * as users from "@/store/modules/users.js";
import * as logs from "@/store/modules/logs.js";
import * as oficialia from "@/store/modules/oficialia.js";
import * as tocas from "@/store/modules/tocas.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    partes,
    users,
    logs,
    oficialia,
    tocas
  },
  state: {
    layout: "dashboard-layout",
    loading: false,
    notification: ""
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      // payload = { tipo: 'success', message:'el mensaje de success'}
      state.notification = Object.assign({}, payload);
    },
    CLEAR_NOTIFICATION(state, payload) {
      state.notification = { tipo: "", message: "" };
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
    }
  },
  actions: {},
  getters: {}
});
